import React, { useEffect, useState } from "react";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
  gridClasses,
} from "@mui/x-data-grid";
import { Grid } from "@mui/material";

const columns = [
  { field: "id", headerName: "ID", width: 50, disableExport: true },
  {
    field: "subject",
    headerName: "Subject",
    width: 130,
    editable: true,
  },
  {
    field: "catest12",
    headerName: "CA 1",
    width: 70,
    type: "number",
    editable: true,
  },
  {
    field: "catest34",
    headerName: "CA 2",
    width: 70,
    type: "number",
    editable: true,
  },
  {
    field: "catest56",
    headerName: "CA 3",
    width: 70,
    type: "number",
    editable: true,
  },
  {
    field: "exam",
    headerName: "Exam",
    type: "number",
    width: 70,
    editable: true,
  },
  {
    field: "total",
    headerName: "Total",
    type: "number",
    width: 70,
    valueGetter: (params) => {
      const total =
        params.row.catest12 +
        params.row.catest34 +
        params.row.catest56 +
        params.row.exam;
      return total;
    },
  },
  {
    field: "grade",
    headerName: "Grade",
    width: 120,
    valueGetter: (params) => {
      const total =
        params.row.catest12 +
        params.row.catest34 +
        params.row.catest56 +
        params.row.exam;

      return getGrade(total);
    },
  },
  {
    field: "highestScore",
    headerName: (
      <Grid
        container
        justifyContent="center"
        sx={{
          "& > *": {
            lineHeight: "1.6rem",
          },
        }}>
        <Grid item>Highest</Grid>
        <Grid item>In Class</Grid>
      </Grid>
    ),
    type: "number",
    width: 110,
    editable: true,
  },
  {
    field: "lowestScore",
    headerName: (
      <Grid
        container
        justifyContent="center"
        sx={{
          "& > *": {
            lineHeight: "1.6rem",
          },
        }}>
        <Grid item>Lowest</Grid>
        <Grid item>In Class</Grid>
      </Grid>
    ),
    type: "number",
    width: 110,
    editable: true,
  },
];

export default function ResultTable({ subjectData, setSubjectData }) {
  return (
    <div style={{ width: "100%" }}>
      <DataGrid
        autoHeight
        headerHeight={100}
        style={{ maxWidth: 880, margin: "0px auto" }}
        density="compact"
        hideFooter
        onCellEditCommit={(params) => {
          const { field, value, id } = params;
          if (
            field === "catest12" ||
            field === "catest34" ||
            field === "catest56" ||
            field === "exam"
          )
            setSubjectData((prev) => {
              const rowID = id;
              let catest12 =
                field === "catest12" ? value : prev[rowID - 1].catest12;
              let catest34 =
                field === "catest34" ? value : prev[rowID - 1].catest34;
              let catest56 =
                field === "catest56" ? value : prev[rowID - 1].catest56;

              let exam = field === "exam" ? value : prev[rowID - 1].exam;
              const total = catest12 + catest34 + catest56 + exam;
              return [
                ...prev.slice(0, rowID - 1),
                {
                  ...prev[rowID - 1],
                  total,
                  grade: getGrade(total),
                  [field]: value,
                },
                ...prev.slice(rowID),
              ];
            });
          else
            setSubjectData((prev) => {
              const rowID = id;
              return [
                ...prev.slice(0, rowID - 1),
                {
                  ...prev[rowID - 1],
                  [field]: value,
                },
                ...prev.slice(rowID),
              ];
            });
        }}
        components={{
          Toolbar: CustomToolbar,
        }}
        rows={subjectData}
        columns={columns}
        // pageSize={5}
        rowsPerPageOptions={[10]}
        // checkboxSelection
        disableSelectionOnClick
      />
    </div>
  );
}
function CustomToolbar() {
  return (
    <GridToolbarContainer className={gridClasses.toolbarContainer}>
      <GridToolbarExport />
    </GridToolbarContainer>
  );
}

/* {
    id: prev.length + 1,
    subject: "",
    "catest1": 0,
    "catest2": 0,
    "catest3": 0,
    "catest4": 0,
    exam: 0,
    total: 0,
    grade: "",
    highestScore: "",
    lowestScore: "",

} */

const getGrade = (total) => {
  let grade = "_ _";
  if (total < 40) grade = "F Failed";
  if (total >= 40 && total < 50) grade = "P Average";
  if (total >= 50 && total < 60) grade = "C Good";
  if (total >= 60 && total < 70) grade = "B Very Good";
  if (total >= 70 && total < 90) grade = "A Excellent";
  if (total >= 90 && total <= 100) grade = "A+ Excellent";

  return grade;
};
